export function PageHeader({ eyebrow, title, subtitle, action }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow && <div className="hw-eyebrow mb-2">{eyebrow}</div>}
        <h1 className="font-head text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">{title}</h1>
        {subtitle && <p className="mt-2 max-w-2xl text-slate-400">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
